import React, { lazy, Suspense } from "react";

const LazyReListRentContract = lazy(() =>
  import("./ReRentContract/ReListRentContract")
);
const LazyReListSellContract = lazy(() =>
  import("./SellContract/ReListSellContract")
);
const LazyReEditContractRentList = lazy(() =>
  import("./ReRentContract/ReEditContractRentList")
);
const LazyReEditContractSell = lazy(() =>
  import("./SellContract/ReEditContractSell")
);
export const ReListRentContract = () => (
  <Suspense fallback="loading...">
    <LazyReListRentContract />
  </Suspense>
);
export const ReListSellContract = () => (
  <Suspense fallback="loading...">
    <LazyReListSellContract />
  </Suspense>
);
export const ReEditContractRentList = () => (
  <Suspense fallback="loading...">
    <LazyReEditContractRentList />
  </Suspense>
);
export const ReEditContractSell = () => (
  <Suspense fallback="loading...">
    <LazyReEditContractSell />
  </Suspense>
);
